import { render } from "./ProjectFooter.vue?vue&type=template&id=5fe749ce&scoped=true&ts=true"
import script from "./ProjectFooter.vue?vue&type=script&lang=ts&scoped=true"
export * from "./ProjectFooter.vue?vue&type=script&lang=ts&scoped=true"

import "./ProjectFooter.vue?vue&type=style&index=0&id=5fe749ce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe749ce"]])

export default __exports__